/*
 * REVIEW-COMMENT-MODAL - Review Comment Collection Modal for Timesheet Approval/Rejection
 * 
 * SUMMARY:
 * Modal component that collects an optional review comment from users when approving
 * or rejecting timesheet allocations. Works for both individual and bulk operations.
 * 
 * PROPS:
 * @param {boolean} open - Controls modal visibility
 * @param {function} onClose - Callback when modal is closed/cancelled
 * @param {function} onSubmit - Callback when comment is submitted (receives comment string)
 * @param {string} action - Action type: "APPROVED" or "REJECTED"
 * @param {boolean} isBulk - Whether this is a bulk operation
 */

import React, { useState, useEffect } from 'react'
import Modal from '../modal/modal'
import TextAreaInput from '../inputs/textarea-input'
import './../modal/modal.scss'

export default function ReviewCommentModal(props) {
  const {
    open,
    onClose,
    onSubmit,
    action,
    isBulk = false,
  } = props

  const [comment, setComment] = useState('')

  // Reset comment when modal opens/closes
  useEffect(() => {
    if (!open) {
      setComment('')
    }
  }, [open])

  const getModalHeading = () => {
    if (isBulk) {
      switch (action) {
        case 'APPROVED':
          return 'Bulk Approve Timesheet Records'
        case 'REJECTED':
          return 'Bulk Reject Timesheet Records'
        case 'PENDING':
          return 'Bulk Set as Pending'
        default:
          return 'Bulk Action'
      }
    } else {
      switch (action) {
        case 'APPROVED':
          return 'Approve Timesheet Record'
        case 'REJECTED':
          return 'Reject Timesheet Record'
        case 'PENDING':
          return 'Set as Pending'
        default:
          return 'Review Timesheet'
      }
    }
  }

  const handleSubmit = () => {
    if (comment.length > 1000) return;
    onSubmit(comment || '')
    setComment('')
  }

  const handleClose = () => {
    setComment('')
    onClose()
  }

  const isInvalid = comment.length > 1000;

  return (
    <Modal
      open={open}
      onClose={handleClose}
      fullWidth={true}
      maxWidth='sm'
      modalHeading={getModalHeading()}
      modalSaveTxt='Submit'
      modalSaveTxtDisabledClass={isInvalid ? 'disabled-btn' : ''}
      modalCloseTxt='Cancel'
      onClick={handleSubmit}
      showActionBtn
      savebtnClass='createBtn'
      cxlbtnClass='cancelBtn'
      primary
    >
      <div style={{ marginBottom: '16px' }}>
        <TextAreaInput
          name="reviewComment"
          label="Review comment"
          placeholder="Enter your review comment (optional)"
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          rows={4}
          maxLength={1000}
          dataCy="review-comment-textarea"
        />
      </div>
    </Modal>
  )
}
